<template>
  <v-app dark class="tech-app-wrapper">
    <div class="circuit-overlay"></div>
    <div class="scanlines"></div>

    <section class="content-relative">
      <v-container>
        
        <v-row justify="center" class="mb-8">
          <v-col cols="12" class="text-center">
            <v-icon size="70" color="cyan accent-3" class="mb-4 glow-icon">mdi-shield-key-outline</v-icon>
            <h1 class="text-h3 font-weight-black white--text text-uppercase neon-text tracking-widest">
              Pasos para obtener un dominio .ni
            </h1>
            <div class="subtitle-text cyan--text text--lighten-3 mono-font mt-2">
              > Iniciando secuencia de adquisición..._
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card class="tech-card rounded-lg overflow-hidden elevation-10">
              
              <v-stepper v-model="e1" class="tech-stepper transparent-bg" alt-labels>
                <v-stepper-header class="elevation-0 border-bottom-neon">
                  <v-stepper-step :complete="e1 > 1" step="1" color="cyan accent-3" class="tech-step">
                    <span class="white--text font-weight-bold">Verifica tu Dominio</span>
                  </v-stepper-step>

                  <v-divider class="neon-divider"></v-divider>

                  <v-stepper-step :complete="e1 > 2" step="2" color="cyan accent-3" class="tech-step">
                    <span class="white--text font-weight-bold">Completar Documentos</span>
                  </v-stepper-step>

                  <v-divider class="neon-divider"></v-divider>

                  <v-stepper-step :complete="e1 > 3" step="3" color="cyan accent-3" class="tech-step">
                    <span class="white--text font-weight-bold">Pago de Dominio</span>
                  </v-stepper-step>

                  <v-divider class="neon-divider"></v-divider>

                  <v-stepper-step step="4" color="green accent-3" class="tech-step">
                    <span class="white--text font-weight-bold">Todo Listo!</span>
                  </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  
                  <v-stepper-content step="1" class="pa-8">
                    <v-row align="center">
                      <v-col cols="12" md="7">
                        <div class="step-label cyan--text mono-font mb-4">>> FASE 1: INICIALIZACIÓN</div>
                        <h2 class="text-h4 white--text font-weight-bold mb-6 text-shadow-blue">
                          {{ pasos[0].titulo }}
                        </h2>
                        
                        <div class="console-box pa-6 rounded border-cyan mb-6">
                          <p class="white--text mb-4 text-body-1" style="line-height: 1.8">
                            Un nombre de dominio tiene que ser único. para saber si el nombre de dominio que deseas está disponible ve a
                            <span class="cyan--text font-weight-bold">WhoIs</span> y asegúrate que aún no exista.
                          </p>
                          <v-btn 
                            to="/whois" 
                            target="_blank"
                            outlined 
                            color="cyan accent-3" 
                            class="neon-btn glow-on-hover"
                            large
                          >
                            <v-icon left>mdi-radar</v-icon> IR A WHOIS
                          </v-btn>
                        </div>

                        <div class="mt-6">
                          <h3 class="text-h5 white--text mb-2">{{ continuapasos[0].titulo }}</h3>
                          <p class="grey--text text--lighten-2 mb-2">{{ continuapasos[0].parrafo }}</p>
                          <p class="grey--text text--lighten-2 mb-4">{{ continuapasos[0].parrafo2 }}</p>
                          
                          <v-dialog v-model="dialog" width="700" scrollable>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn 
                                color="blue accent-3" 
                                text 
                                v-bind="attrs" 
                                v-on="on" 
                                class="pl-0 hover-underline mt-2"
                              >
                                <v-icon left>mdi-table-search</v-icon> {{ continuapasos[0].titulomodal }}
                              </v-btn>
                            </template>

                            <v-card class="tech-card border-neon">
                              <v-card-title class="headline cyan darken-4 white--text border-bottom-neon">
                                <v-icon left color="white">mdi-database</v-icon>
                                {{ continuapasos[0].titulomodal }}
                              </v-card-title>

                              <v-card-text class="pa-0">
                                <v-simple-table dark class="tech-table">
                                  <template v-slot:default>
                                    <thead>
                                      <tr>
                                        <th class="text-left cyan--text text-uppercase">Sector</th>
                                        <th class="text-left cyan--text text-uppercase">Dominio</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="item in dominisoNi" :key="item.name" class="row-hover">
                                        <td>{{ item.sector }}</td>
                                        <td class="mono-font cyan--text">{{ item.dominio }}</td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-card-text>

                              <v-card-actions class="grey darken-4">
                                <v-spacer></v-spacer>
                                <v-btn color="red accent-2" text @click="dialog = false">
                                  [X] CERRAR
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </div>

                      </v-col>
                      <v-col cols="12" md="5" class="d-flex justify-center">
                        <div class="hologram-frame">
                          <v-icon size="180" color="cyan accent-2" class="glow-icon-large floating-icon">
                            {{ pasos[0].icon }}
                          </v-icon>
                        </div>
                      </v-col>
                    </v-row>

                    <div class="d-flex justify-end mt-6">
                      <v-btn color="cyan accent-4" large @click="e1 = 2" class="black--text font-weight-bold neon-bg">
                        Siguiente >
                      </v-btn>
                    </div>
                  </v-stepper-content>

                  <v-stepper-content step="2" class="pa-8">
                    <div class="step-label cyan--text mono-font mb-4">>> FASE 2: DOCUMENTACIÓN</div>
                    <h2 class="text-h4 white--text font-weight-bold mb-6 text-shadow-blue">
                      {{ pasos2[0].titulo }}
                    </h2>
                    
                    <v-row>
                      <v-col cols="12" md="7">
                        <p class="white--text mb-6 text-h6 font-weight-light">{{ pasos2[0].parrafo }}</p>
                        
                        <div class="info-block mb-4 pl-4 border-left-cyan">
                          <strong class="cyan--text text-uppercase">Carta De Compromiso:</strong> 
                          <span class="grey--text text--lighten-2">{{ pasos2[0].parrafo2 }}</span>
                        </div>
                        <div class="info-block mb-4 pl-4 border-left-cyan">
                          <strong class="cyan--text text-uppercase">Formulario de Solicitud:</strong> 
                          <span class="grey--text text--lighten-2">{{ pasos2[0].parrafo3 }}</span>
                        </div>
                        <div class="info-block mb-6 pl-4 border-left-orange">
                          <strong class="orange--text text--accent-2 text-uppercase">Nota Importante:</strong> 
                          <span class="grey--text text--lighten-2">{{ pasos2[0].parrafo4 }}</span>
                        </div>
                      </v-col>
                      
                      <v-col cols="12" md="5">
                         <v-card outlined color="transparent" class="border-blue pa-4">
                          <div class="d-flex align-center mb-4">
                            <v-icon color="blue" left>mdi-folder-download</v-icon> 
                            <span class="mono-font blue--text">/root/descargas/</span>
                          </div>

                          <v-list dense color="transparent" dark class="file-list-scroll">
                            
                            <v-list-item 
                              href="https://webimg.uni.edu.ni/pdf/ComunicadosAcuerdos/Plantilla%20de%20Registro%20-%20Registradores%20Internacionales%20Autorizados.pdf" target="_blank"
                              class="file-item mb-2 rounded"
                            >
                              <v-list-item-icon><v-icon color="green accent-3">mdi-file-pdf-box</v-icon></v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="white--text">Plantilla Registro Internacionales</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action><v-icon color="cyan" small>mdi-download</v-icon></v-list-item-action>
                            </v-list-item>

                            <v-list-item 
                              href="https://webimg.uni.edu.ni/pdf/ComunicadosAcuerdos/CARTA%20DE%20COMPROMISO%20REGISTRADOR%20AUTORIZADO.docx" target="_blank"
                              class="file-item mb-2 rounded"
                            >
                              <v-list-item-icon><v-icon color="blue accent-3">mdi-file-word</v-icon></v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="white--text">Carta Compromiso Registrador</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action><v-icon color="cyan" small>mdi-download</v-icon></v-list-item-action>
                            </v-list-item>

                            <v-list-item 
                              href="https://webimg.uni.edu.ni/pdf/ComunicadosAcuerdos/Plantilla%20de%20Registro%20Registrantes%20Nacionales.pdf" target="_blank"
                              class="file-item mb-2 rounded"
                            >
                              <v-list-item-icon><v-icon color="green accent-3">mdi-file-pdf-box</v-icon></v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="white--text">Plantilla Registrantes Nacionales</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action><v-icon color="cyan" small>mdi-download</v-icon></v-list-item-action>
                            </v-list-item>

                            <v-list-item 
                              href="https://webimg.uni.edu.ni/pdf/ComunicadosAcuerdos/CARTA%20DE%20COMPROMISO%20CONTRIBUYENTE%20JURÍDICO.docx" target="_blank"
                              class="file-item mb-2 rounded"
                            >
                              <v-list-item-icon><v-icon color="blue accent-3">mdi-file-word</v-icon></v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="white--text">Carta Compromiso (Jurídico)</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action><v-icon color="cyan" small>mdi-download</v-icon></v-list-item-action>
                            </v-list-item>

                            <v-list-item 
                              href="https://webimg.uni.edu.ni/pdf/ComunicadosAcuerdos/CARTA%20DE%20COMPROMISO%20CONTRIBUYENTE%20NATURAL.docx" target="_blank"
                              class="file-item mb-2 rounded"
                            >
                              <v-list-item-icon><v-icon color="blue accent-3">mdi-file-word</v-icon></v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="white--text">Carta Compromiso (Natural)</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action><v-icon color="cyan" small>mdi-download</v-icon></v-list-item-action>
                            </v-list-item>

                            <v-list-item 
                              href="https://webimg.uni.edu.ni/pdf/ComunicadosAcuerdos/CARTA%20DE%20COMPROMISO%20PERSONA%20NATURAL%20NO%20CONTRIBUYENTE.docx" target="_blank"
                              class="file-item mb-2 rounded"
                            >
                              <v-list-item-icon><v-icon color="blue accent-3">mdi-file-word</v-icon></v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="white--text">Carta No Contribuyente</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action><v-icon color="cyan" small>mdi-download</v-icon></v-list-item-action>
                            </v-list-item>

                          </v-list>
                        </v-card>
                      </v-col>
                    </v-row>

                    <div class="d-flex justify-space-between mt-8">
                      <v-btn text color="grey lighten-1" @click="e1 = 1">
                        <v-icon left>mdi-arrow-left</v-icon> Atrás
                      </v-btn>
                      <v-btn color="cyan accent-4" large @click="e1 = 3" class="black--text font-weight-bold neon-bg">
                        Siguiente >
                      </v-btn>
                    </div>
                  </v-stepper-content>

                  <v-stepper-content step="3" class="pa-8">
                    <v-row align="center">
                      <v-col cols="12" md="7">
                        <div class="step-label cyan--text mono-font mb-4">>> FASE 3: PAGO</div>
                        <h2 class="text-h4 white--text font-weight-bold mb-4 text-shadow-blue">
                          {{ pasos3[0].titulo }}
                        </h2>
                        
                        <v-card color="rgba(0,0,0,0.4)" class="border-neon pa-6 mb-6">
                          <p class="white--text mb-6 text-justify text-body-1">
                            {{ pasos3[0].parrafo }}
                          </p>
                          <div class="d-flex align-center">
                            <v-icon size="50" color="green accent-3" class="mr-4">mdi-cash-register</v-icon>
                            <div>
                              <div class="caption grey--text">MONTO REQUERIDO</div>
                              <div class="text-h3 font-weight-black green--text text--accent-3 mono-font">C$ 1,850.00</div>
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="5" class="d-flex justify-center">
                         <div class="hologram-frame circle-frame">
                          <v-icon size="160" color="green accent-3" class="glow-icon-large">
                            {{ pasos3[0].icon }}
                          </v-icon>
                        </div>
                      </v-col>
                    </v-row>

                    <div class="d-flex justify-space-between mt-8">
                      <v-btn text color="grey lighten-1" @click="e1 = 2">
                        <v-icon left>mdi-arrow-left</v-icon> Atrás
                      </v-btn>
                      <v-btn color="cyan accent-4" large @click="e1 = 4" class="black--text font-weight-bold neon-bg">
                        Siguiente >
                      </v-btn>
                    </div>
                  </v-stepper-content>

                  <v-stepper-content step="4" class="pa-8">
                    <v-row justify="center" class="text-center">
                      <v-col cols="12" md="8">
                        <div class="mb-6">
                           <v-icon size="120" color="green accent-3" class="glow-icon-large floating-icon">
                             {{ pasos4[0].icon }}
                           </v-icon>
                        </div>
                        
                        <h2 class="text-h3 white--text font-weight-black mb-6 neon-text">Todo Listo!</h2>
                        
                        <p class="text-h6 white--text mb-4 text-justify">
                          {{ pasos4[0].parrafo }}
                        </p>
                        
                        <p class="text-body-1 grey--text text--lighten-2 mb-8">
                          {{ pasos4[0].parrafo2 }}
                        </p>

                        <v-btn 
                          to="/contactenos"
                          x-large 
                          outlined 
                          color="cyan accent-3" 
                          class="neon-btn mr-4 glow-on-hover"
                        >
                          <v-icon left>mdi-headset</v-icon> CONTÁCTENOS
                        </v-btn>
                        
                        <div class="mt-6">
                          <v-btn text color="grey" @click="e1 = 3">
                            <v-icon left>mdi-arrow-left</v-icon> Atrás
                          </v-btn>
                          <v-btn text color="grey" @click="e1 = 1">
                            <v-icon left>mdi-refresh</v-icon> Reiniciar
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-stepper-content>

                </v-stepper-items>
              </v-stepper>
            </v-card>
          </v-col>
        </v-row>

      </v-container>
    </section>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      title: "Información General",
      dialog: false,
      e1: 1,
      // DATOS CON ICONOS EN LUGAR DE IMAGENES
      pasos: [
        {
          titulo: "#1 - Verifica que tu dominio se encuentre disponible",
          icon: "mdi-web-check", // Icono paso 1
        },
      ],
      pasos2: [
        {
          titulo: "#2 - Completa los siguientes documentos",
          parrafo: "y completa los documentos necesarios para hacer constatar la legalidad y pertenencia de tu nuevo dominio .ni. Estos documentos son:",
          parrafo2: "Es necesario para nosotros que el solicitante, ya sea una empresa o una persona firme un compromiso de responsabilidad y cumplimiento de las normas establecidas para la adquicision de un nuevo dominio .ni.",
          parrafo3: "En este documento se detalla todo acerca de tu dominio, a saber, el nombre de tu nuevo dominio; los contactos; la IP correspondiente y DNS.",
          parrafo4: "Nota: Si el solicitante del nuevo dominio .ni es representante de una empresa, éste deberá entregar una carta poder para constatar que realmente representa a la empresa que adquirirá el dominio.",
          url: "https://www.nic.ni",
        },
        // El segundo objeto ya no es necesario para la imagen, se maneja arriba o se ignora
      ],
      pasos3: [
        {
          titulo: "#3 - Especificaciones de pago de tu nuevo dominio de tercer nivel",
          icon: "mdi-cash", // Icono paso 3
          parrafo: "El costo del dominio es por C$1,850.00 córdobas en efectivo, pago únicamente en caja general de la UNI, antes debe presentarse en nuestras oficinas de atención al cliente NIC, ubicada contiguo a la División de Finanzas, en el Recinto Universitarios Simón Bolívar, frente a la escuela de danza, ahí le realizaran una orden de servicio, luego se dirige a caja. ",
        },
      ],
      pasos4: [
        {
          parrafo: "Después de haber realizado estos pasos, la activación de tu nuevo dominio tomará 24 horas. Puedes buscar tu dominio en el WHOIS para verificar que ya esté activo.",
          parrafo2: "Para saber más acerca de cómo adquirir un nuevo dominio .ni por favor.",
          icon: "mdi-rocket-launch", // Icono paso 4
        },
      ],
      continuapasos: [
        {
          titulo: "¿Qué tipo de Dominio debería elegir?",
          icon: "mdi-help-network-outline", 
          parrafo: "Existen diversos tipos de dominios cada uno en relacion a la actividad desarrollada dentro un sector específico (ejemplo .gob.ni - Gobierno, .edu.ni - Educación, .org.ni Organizaciones, etc). Estos dominios son comunmente conocidos como dominios de tercer nivel",
          parrafo2: "El NIC.NI tambien tiene disponibles dominios de segundo nivel (ejemplo: miempresa.ni)",
          titulomodal: "Tabla de Zonas para Dominios .ni",
        },
      ],
      dominisoNi: [
        { sector: "Sector General", dominio: ".ni" },
        { sector: "Comercial", dominio: ".com.ni" },
        { sector: "Educativo", dominio: ".edu.ni" },
        { sector: "Corporativo", dominio: ".co.ni" },
        { sector: "Tecnología en redes", dominio: ".net.ni" },
        { sector: "Internacionales", dominio: ".int.ni" },
        { sector: "Gobierno", dominio: ".gob.ni" },
        { sector: "Organizaciones", dominio: ".org.ni" },
        { sector: "Salud", dominio: ".med.ni" },
      ],
    };
  },
  methods: {
    scrollTop() {
      setTimeout(() => {
        window.scrollTo({
          top: 380,
          behavior: 'smooth'
        });
      }, 200);
    },
  },
};
</script>

<style scoped>
/* --- ESTÉTICA CYBERPUNK / HIGH-TECH --- */

/* Fuentes y Fondo Base */
@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;900&display=swap');

.tech-app-wrapper {
  background-color: #050a14 !important; /* Negro azulado profundo */
  font-family: 'Montserrat', sans-serif;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.mono-font {
  font-family: 'Fira Code', monospace !important;
}

.tracking-widest {
  letter-spacing: 3px;
}

/* Efectos de Fondo */
.circuit-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background-image: 
    radial-gradient(circle at 10% 20%, rgba(0, 255, 255, 0.05) 0%, transparent 40%),
    linear-gradient(0deg, rgba(0,0,0,0.2) 50%, transparent 50%);
  background-size: cover, 4px 4px;
  z-index: 0;
}

.scanlines {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0) 50%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0.2));
  background-size: 100% 4px;
  pointer-events: none;
  z-index: 1;
}

.content-relative {
  position: relative;
  z-index: 2;
}

/* Texto Neón */
.neon-text {
  text-shadow: 0 0 10px rgba(0, 229, 255, 0.6), 0 0 20px rgba(0, 229, 255, 0.3);
}
.text-shadow-blue {
  text-shadow: 0 2px 10px rgba(41, 121, 255, 0.5);
}
.glow-icon {
  filter: drop-shadow(0 0 8px cyan);
}
.glow-icon-large {
  filter: drop-shadow(0 0 15px rgba(0, 255, 255, 0.5));
}

/* Stepper Personalizado */
.tech-stepper {
  background: transparent !important;
  box-shadow: none !important;
}
.border-bottom-neon {
  border-bottom: 1px solid rgba(0, 255, 255, 0.3) !important;
}
.neon-divider {
  border-color: rgba(0, 255, 255, 0.2) !important;
}

/* Tarjetas y Contenedores */
.tech-card {
  background: rgba(13, 25, 45, 0.9) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 255, 255, 0.15) !important;
  box-shadow: 0 0 30px rgba(0,0,0,0.8);
}

.console-box {
  background: rgba(0, 0, 0, 0.6);
  border-left: 3px solid cyan;
}

.border-neon {
  border: 1px solid cyan !important;
}
.border-blue {
  border: 1px solid rgba(41, 121, 255, 0.5) !important;
}
.border-left-cyan {
  border-left: 3px solid cyan;
}
.border-left-orange {
  border-left: 3px solid #FFAB40;
}

/* Botones Neon */
.neon-btn {
  border-width: 2px;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.1);
  transition: all 0.3s;
}
.glow-on-hover:hover {
  box-shadow: 0 0 20px cyan;
  background-color: rgba(0, 255, 255, 0.1);
}
.neon-bg {
  background: linear-gradient(90deg, #00e5ff, #00b8d4) !important;
  box-shadow: 0 0 15px rgba(0, 229, 255, 0.4);
}

/* Lista de Archivos */
.file-item {
  border: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(255, 255, 255, 0.02);
  transition: all 0.2s;
}
.file-item:hover {
  background: rgba(0, 255, 255, 0.05);
  border-color: rgba(0, 255, 255, 0.3);
}
.file-list-scroll {
  max-height: 400px;
  overflow-y: auto;
}
.file-list-scroll::-webkit-scrollbar {
  width: 5px;
}
.file-list-scroll::-webkit-scrollbar-thumb {
  background: cyan;
  border-radius: 5px;
}

/* Imágenes y Hologramas */
.hologram-frame {
  position: relative;
  border: 2px solid cyan;
  padding: 20px;
  background: rgba(0, 255, 255, 0.05);
  box-shadow: inset 0 0 20px rgba(0, 255, 255, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.hologram-frame::before, .hologram-frame::after {
  content: '';
  position: absolute;
  width: 20px; height: 20px;
  border: 2px solid white;
  transition: all 0.3s;
}
.hologram-frame::before { top: -2px; left: -2px; border-right: none; border-bottom: none; }
.hologram-frame::after { bottom: -2px; right: -2px; border-left: none; border-top: none; }

.circle-frame {
  border-radius: 50%;
  border: 2px dashed cyan;
  padding: 40px;
  animation: spin 60s linear infinite;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Tablas */
.tech-table {
  background: transparent !important;
}
.tech-table th {
  border-bottom: 2px solid cyan !important;
}
.tech-table td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}
.row-hover:hover {
  background-color: rgba(0, 255, 255, 0.1) !important;
}

/* Animaciones */
@keyframes spin { 100% { transform: rotate(360deg); } }

.floating-icon {
  animation: float 4s ease-in-out infinite;
}
@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
  100% { transform: translateY(0px); }
}

/* Utilidades */
.hover-underline:hover {
  text-decoration: underline;
  text-decoration-color: cyan;
}
.transparent-bg {
  background: transparent !important;
}
</style>